var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileToolbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.9982 8.13348V19.8647C27.9982 23.7985 26.1923 26.5003 23.0145 27.5222C22.0906 27.8442 21.0267 27.9982 19.8647 27.9982H8.13348C6.97155 27.9982 5.90762 27.8442 4.98368 27.5222C1.80588 26.5003 0 23.7985 0 19.8647V8.13348C0 3.0378 3.0378 0 8.13348 0H19.8647C24.9604 0 27.9982 3.0378 27.9982 8.13348Z",
    fill: "#3F4254"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0152 27.5241C22.0913 27.8461 21.0274 28.0001 19.8654 28.0001H8.13417C6.97225 28.0001 5.90832 27.8461 4.98438 27.5241C5.47434 23.8283 9.3381 20.9585 13.9998 20.9585C18.6615 20.9585 22.5253 23.8283 23.0152 27.5241Z",
    fill: "#3F4254"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0107 13.4106C19.0107 16.1825 16.7708 18.4363 13.999 18.4363C11.2272 18.4363 8.9873 16.1825 8.9873 13.4106C8.9873 10.6388 11.2272 8.39893 13.999 8.39893C16.7708 8.39893 19.0107 10.6388 19.0107 13.4106Z",
    fill: "#3F4254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileToolbar);
export default __webpack_public_path__ + "static/media/profile_toolbar.70944177da99b4af9b930fde577148cc.svg";
export { ForwardRef as ReactComponent };